export enum CHARGE_TYPE {
    BALANCE = 1,
    PAIRS,
}

export enum JOB_STATUS {
    SUCCESS = 1,
    FAIL = 2,
}
